module.exports = __webpack_public_path__ + "img/add-circle-w.6d62acf6.svg";